<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="teal">
          <v-icon medium>person_add</v-icon>
          <v-toolbar-title>เพิ่มบุคคล</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container fluid>
              <v-layout row wrap>
          
                <!-- PART I -->
                <v-flex d-flex xs12 md6>
                  <v-card>
                    <v-toolbar dark color="blue darken-3">
                      <v-toolbar-title>
                        พื้นฐาน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-container grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs12 md4>
                            <v-select
                              :items="prenameThItems"
                              v-model="personData.personName.titleTh"
                              label="คำนำหน้า(ไทย)"
                              single-line
                            ></v-select>
                          </v-flex>                      
                          <v-flex xs12 md4>
                            <v-text-field
                              label="ชื่อ(ไทย)"
                              id="firstnameTh"
                              v-model="personData.personName.firstnameTh"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="นามสกุล(ไทย)"
                              id="lastnameTh"
                              v-model="personData.personName.lastnameTh"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md4>
                            <v-select
                              :items="prenameEnItems"
                              v-model="personData.personName.titleEn"
                              label="คำนำหน้า(อังกฤษ)"
                              single-line
                              hint="*ไม่สามารถเป็นค่าว่าง"
                              persistent-hint
                              class="warning--text"
                            ></v-select>
                          </v-flex>                      
                          <v-flex xs12 md4>
                            <v-text-field
                              label="ชื่อ(อังกฤษ)"
                              id="firstnameEn"
                              v-model="personData.personName.firstnameEn"
                              hint="*ไม่สามารถเป็นค่าว่าง"
                              persistent-hint
                              class="warning--text"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="นามสกุล(อังกฤษ)"
                              id="lastnameEn"
                              v-model="personData.personName.lastnameEn"
                              hint="*ไม่สามารถเป็นค่าว่าง"
                              persistent-hint
                              class="warning--text"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md4>
                            <v-text-field
                              label="ชื่อเล่น"
                              id="nickname"
                              v-model="personData.nickname"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-menu
                              ref="menuBirthDate"
                              :close-on-content-click="false"
                              v-model="menuBirthDate"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <v-text-field
                                slot="activator"
                                :value="date(personData.birthDate)" 
                                label="วันเกิด"
                                prepend-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker
                                ref="pickerBirthDate"
                                v-model="personData.birthDate"
                                :max="new Date().toISOString().substr(0, 10)"
                                min="1950-01-01"
                                locale="th-Th"
                                @change="saveBirthDate"
                              ></v-date-picker>
                            </v-menu>                            
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-layout row wrap>
                              <p class="grey--text">เพศ</p>
                              <v-radio-group v-model="personData.gender" row>
                                <v-radio label="ชาย" value="M" ></v-radio>
                                <v-radio label="หญิง" value="F"></v-radio>
                              </v-radio-group>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 md4>
                            <v-text-field
                              label="เลขบัตรประจำตัวประชาชน"
                              id="idCard"
                              :mask="'# #### ##### ## #'"
                              v-model="personData.idCard"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="เลขที่พาสปอร์ต"
                              id="passport"
                              v-model="personData.passport"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="เลขที่ทะเบียนรถ"
                              id="vehicle"
                              v-model="personData.vehicle"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md4>
                            <v-text-field
                              label="ธนาคาร"
                              id="bankName"
                              v-model="personData.bankName"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="สาขา"
                              id="bankBranch"
                              v-model="personData.bankBranch"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="เลขที่บัญชี"
                              id="bankAccount"
                              :mask="'###-#-#####-#'"
                              v-model="personData.bankAccount"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="ชื่อบัญชี"
                              id="bankAccountName"
                              v-model="personData.bankAccountName"
                            ></v-text-field>
                          </v-flex>

                        </v-layout>
                      </v-container>
                    </v-card-text>          
                  </v-card>
                </v-flex>
                
                <!-- PART II -->
                <v-flex d-flex xs12 md6>
                  <v-card>
                    <v-toolbar dark color="green darken-3">
                      <v-toolbar-title>
                        ที่อยู่/ติดต่อ
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-container grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-text-field label="เบอร์มือถือ" :mask="mask" v-model="personData.mobile"></v-text-field>
                          </v-flex>

                          <v-flex xs8>
                            <v-text-field
                              label="อีเมล์ส่วนตัว*"
                              v-model="personData.emailPrivate"
                              hint="*ไม่สามารถเป็นค่าว่าง"
                              persistent-hint
                              class="warning--text"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              label="ที่อยู่ตามบัตรประชาชน"
                              color="teal"
                              v-model="personData.addressIdCard"
                              rows="2"
                            >
                            </v-textarea>
                          </v-flex>

                          <v-flex xs12>
                            <v-divider></v-divider>
                            <v-checkbox label="ใช้ที่อยู่ตามบัตรประชาชน" v-model="copyAddress" light></v-checkbox>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              label="ที่อยู่ (ส่งใบกำกับภาษี)"
                              color="teal"
                              v-model="personData.address"
                              rows="2"
                            >
                            </v-textarea>
                          </v-flex>

                        </v-layout>
                      </v-container> 
                    </v-card-text>
                  </v-card>
                </v-flex>

                <!-- PART III -->
                <v-flex d-flex xs12 md12>
                  <v-card>
                    <v-toolbar dark color="purple darken-3">
                      <v-toolbar-title>
                        การทำงาน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-container grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs12 md6>
                            <v-select
                              :items="personTypeItems"
                              v-model="personData.personType"
                              label="ประเภทบุคคล*"
                              item-text="name"
                              single-line
                              return-object
                              :rules="[rules.required]"
                              required
                              hint="*ไม่สามารถเป็นค่าว่าง"
                              persistent-hint
                              class="warning--text"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field label="ตำแหน่ง" v-model="personData.position"></v-text-field>
                          </v-flex>

                          <template v-if="personData.personType.insider">
                            <v-flex xs12 md2>
                              <v-select
                                :items="campusItems"
                                v-model="personData.campus"
                                label="วิทยาเขต"
                                item-text="name"
                                single-line
                                return-object
                                :rules="[rules.required]"
                                required
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md5>
                              <v-select
                                :items="facultyItems"
                                v-model="personData.faculty"
                                label="คณะ"
                                item-text="nameTh"
                                single-line
                                return-object
                                :rules="[rules.required]"
                                required
                                @input="departmentItems = personData.faculty.departments"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md5>
                              <v-select
                                :items="departmentItems"
                                v-model="personData.department"
                                label="สาขา"
                                item-text="name"
                                single-line
                                return-object
                                :rules="[rules.required]"
                                required
                              ></v-select>
                            </v-flex>
                          </template>

                          <!-- <template v-if="personData.department.code === 'GEN'"> -->
                          <template v-if="gened">
                            <v-flex xs12 md3>
                              <v-layout row wrap>
                                <v-subheader v-text="'สถานะ'"></v-subheader>
                                <v-radio-group v-model="personData.employeeType" required row>
                                  <v-radio label="พนักงาน" value="EMPLOYEE" color="orange"></v-radio>
                                  <v-radio label="ลูกจ้าง" value="CONTRACT" color="orange"></v-radio>
                                </v-radio-group>
                              </v-layout>    
                            </v-flex>
                            <v-flex xs12 md4>
                              <v-menu
                                ref="menuStartingDate"
                                :close-on-content-click="false"
                                v-model="menuStartingDate"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  :value="date(personData.startingDate)" 
                                  label="วันที่เริ่มทำงาน"
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker
                                  ref="pickerStartingDate"
                                  v-model="personData.startingDate"
                                  :max="new Date().toISOString().substr(0, 10)"
                                  min="1950-01-01"
                                  locale="th-Th"
                                  @change="saveStartingDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>

                            <v-flex xs12 md5>
                              <v-text-field 
                              label="เลขที่ตำแหน่ง" 
                              v-model="personData.positionNo" 
                              :rules="[rules.required]"
                              required></v-text-field>
                            </v-flex>
                          </template>

                          <v-flex xs4>
                            <v-text-field label="เบอร์ภายใน" :mask="mask" v-model="personData.internalPhone"></v-text-field>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field
                              label="อีเมล์มหาวิทยาลัย"
                              v-model="personData.emailOfficial"
                            ></v-text-field>
                          </v-flex>

                        </v-layout>
                      </v-container> 
                    </v-card-text>
                  </v-card>
                </v-flex>

                <!-- <v-flex xs12>
                  <v-layout>
                  <v-spacer></v-spacer>
                  <v-btn color="grey white--text" @click="close">ปิด</v-btn>
                  <v-btn
                    color="green white--text"
                    @click="submit"
                    :disabled="!valid"
                  >
                    บันทึก
                  </v-btn>
                  </v-layout>
                </v-flex> -->

              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" @click="close">ปิด</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green white--text" @click="submit" :disabled="!valid">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
  props: ['dialog'],
  data () {
    return {
      copyAddress: false,
      departmentItems: [],
      gened: false,
      mask: 'phone',
      menuBirthDate: false,
      menuStartingDate: false,
      personData: {
        personName: {},
        personType: {}
      },
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      valid: false,
    }
  },
  computed: {
    ...mapGetters({
      campusItems: 'university/campusItems',
      facultyItems: 'university/facultyItems',
      personTypeItems: 'personType/personTypeItems',
      prenameThItems: 'person/prenameThItems',
      prenameEnItems: 'person/prenameEnItems',
    })
  },
  methods: {
    clear () {
      this.$refs.form.reset()
    },
    close () {
      this.$emit('dialog', false)
      // this.clear()
    },
    date (val) {
      return this.$options.filters.formatFullDate(val)
    },
    saveBirthDate (date) {
      this.$refs.menuBirthDate.save(date)
    },
    saveStartingDate (date) {
      this.$refs.menuStartingDate.save(date)
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.cleanUp ()
        this.$store.dispatch('person/create', this.personData)
          .then((response) => {
            // console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    },
    cleanUp () {
      if(!this.gened) this.resetGened()
      if(!this.personData.personType.insider) this.resetUniversity ()
    },
    resetUniversity () {
      this.personData.campus = null
      this.personData.faculty = null
      this.personData.department = null
    },
    resetGened () {
      this.personData.employeeType = null
      this.personData.positionNo = null
      this.personData.startingDate = null
    }
  },
  watch: {
    personData: {
      handler: function(val) {
        // if(!val.personType.insider) this.resetUniversity ()  
        if(val.department) {
          // // console.log('watch->personData->department', val.department )
          if(val.department.code === 'GEN') {
            this.gened = true  
          } else {
            this.gened = false
          }
        }
      },
      deep: true
    },
    menuBirthDate (val) {
      val && this.$nextTick(() => (this.$refs.pickerBirthDate.activePicker = 'YEAR'))
    },
    menuStartingDate (val) {
      val && this.$nextTick(() => (this.$refs.pickerStartingDate.activePicker = 'YEAR'))
    },
    copyAddress (val) {
      if(val) {
        this.personData.address = this.personData.addressIdCard
      } else {
        this.personData.address = null
      }
    }
  }
}
</script>

<style scoped>
  .warning--text >>> .theme--light.v-messages {
    color: #ff6d00 !important
  }
</style>


// WEBPACK FOOTER //
// src/components/management/person/forms/formDialog.vue